import TopicsItem, { TopicsItemData } from "./topicsItem";
import React, { useState } from "react";
import "./topics.scss";
import { graphql } from "gatsby";

interface Props {
  topics: TopicsItemData[];
}

export const query = graphql`
  fragment TopicsBlock on WpAcfTopicsBlock {
    AcfTopics {
      topics {
        topic
        headline
        text
        linkFile {
          label
          file {
            mediaItemUrl
          }
        }
        linkExternal {
          label
          url
        }
      }
    }
  }
`;

const Topics: React.FC<Props> = (props) => {
  const [itemActive, setItemActive] = useState<number | null>(null);
  return (
    <div className="topics">
      {props.topics.map((item, key) => (
        <TopicsItem
          {...item}
          key={key}
          isActive={itemActive === key}
          index={key}
          onExpand={(index) =>
            index === itemActive ? setItemActive(null) : setItemActive(index)
          }
          className="topics__cell"
        />
      ))}
    </div>
  );
};

export default Topics;
